import React from "react";
import { Link } from "react-router-dom";

export const PolicyAgreement = ({
  checked,
  onChange,
  testIdPrefix,
}) => {
  return (
    <label
      className={[
        "flex cursor-pointer items-start gap-3 rounded-lg border border-[#E2DCD2]",
        "bg-[#FDFBF7] p-3",
      ].join(" ")}
      data-testid={`${testIdPrefix}-consent-label`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        className="mt-0.5 h-4 w-4 accent-[#2D5A47]"
        data-testid={`${testIdPrefix}-consent-checkbox`}
        aria-required="true"
      />
      <span className="text-sm leading-5 text-[#1E2A24]">
        I agree to the{" "}
        <Link
          to="/terms-and-conditions"
          className="font-semibold text-[#2D5A47] underline underline-offset-2"
          onClick={(event) => event.stopPropagation()}
          data-testid={`${testIdPrefix}-terms-link`}
        >
          Terms &amp; Conditions
        </Link>
        {" "}and{" "}
        <Link
          to="/privacy-policy"
          className="font-semibold text-[#2D5A47] underline underline-offset-2"
          onClick={(event) => event.stopPropagation()}
          data-testid={`${testIdPrefix}-privacy-link`}
        >
          Privacy Policy
        </Link>
        .
      </span>
    </label>
  );
};